import { jsxs as _, jsx as t } from "react/jsx-runtime";
import { Icon as N, Intent as b, Button as v } from "@blueprintjs/core";
import { IconNames as f } from "@blueprintjs/icons";
import a from "classnames";
import "./main.scss";
import { forwardRef as h } from "react";
import { SliderButton as I } from "@typeform/embed-react";
const B = ({
  label: s,
  isBackNavigationButton: o = !1,
  large: n = !1,
  leftIcon: e = void 0,
  rightIcon: i = void 0,
  onClick: l,
  type: c = "button",
  disabled: d = !1,
  className: r,
  style: p
}) => {
  const m = o ? f.CIRCLE_ARROW_LEFT : e, u = n ? 18 : 14;
  return /* @__PURE__ */ _(
    "button",
    {
      type: c,
      className: a("sds_action-button", r),
      onClick: l,
      disabled: d,
      style: p,
      children: [
        /* @__PURE__ */ t(N, { icon: m, size: u }),
        /* @__PURE__ */ t(
          "span",
          {
            className: a("sds_action-button__label", {
              "sds_action-button__label--small": !n,
              "padding__top--xx-small": n && m
            }),
            children: s
          }
        ),
        /* @__PURE__ */ t(N, { icon: i, size: u })
      ]
    }
  );
}, M = ({
  label: s,
  title: o,
  onClick: n = void 0
}) => /* @__PURE__ */ _("div", { style: { display: "flex", alignItems: "center" }, children: [
  /* @__PURE__ */ t(B, { label: s, isBackNavigationButton: !0, large: !0, onClick: n }),
  /* @__PURE__ */ t("span", { className: "sds_action-button__title--separator", children: "|" }),
  /* @__PURE__ */ t("span", { className: "sds_action-button__title", children: o })
] }), g = {
  PRIMARY: b.PRIMARY,
  NONE: b.NONE,
  DANGER: b.DANGER
}, T = (() => {
  const s = h(
    ({
      label: o,
      intent: n = g.NONE,
      onClick: e,
      disabled: i = !1,
      type: l = "button",
      large: c = !1,
      iconBeforeLabel: d = void 0,
      iconAfterLabel: r = void 0,
      autoFocus: p = !1,
      className: m
    }, u) => /* @__PURE__ */ t(
      v,
      {
        className: a("sds_button", { "sds_button--large": c }, m),
        intent: n,
        text: o,
        onClick: e,
        disabled: i,
        type: l,
        icon: d,
        rightIcon: r,
        autoFocus: p,
        ref: u
      }
    )
  );
  return s.Intent = g, s;
})(), y = ({ hideButton: s = !1, typeformID: o }) => s ? null : /* @__PURE__ */ _(I, { id: o, className: "sds_button__feedback", width: 650, children: [
  /* @__PURE__ */ t(N, { icon: f.COMMENT, size: 14, className: "padding__right--small" }),
  "Help Us Improve"
] }), C = ({
  label: s = void 0,
  helperText: o = void 0,
  isOn: n,
  disabled: e = !1,
  className: i = void 0,
  labelClassName: l = void 0,
  toggleClassName: c = void 0,
  onChange: d = void 0,
  onClick: r = void 0
}) => /* @__PURE__ */ _(
  "div",
  {
    className: a(
      "sds_toggle-button",
      { "sds_toggle-button--disabled": e },
      i
    ),
    children: [
      /* @__PURE__ */ _(
        "div",
        {
          className: a(
            "sds_toggle-button__label",
            "padding__right--small",
            l
          ),
          children: [
            /* @__PURE__ */ t("span", { className: "font-semi-bold--uppercase", children: s }),
            o && /* @__PURE__ */ t("span", { className: "sds_toggle-button__helper-text", children: o })
          ]
        }
      ),
      /* @__PURE__ */ t(
        "input",
        {
          className: a(
            "sds_toggle-button__toggle",
            "font-semi-bold--uppercase",
            c
          ),
          type: "checkbox",
          disabled: e,
          checked: n,
          onChange: d,
          onClick: r
        }
      )
    ]
  }
);
export {
  M as ActionButtonPageTitle,
  B as ActionButtonText,
  T as Button,
  y as FeedbackButton,
  C as ToggleButton
};
//# sourceMappingURL=index.js.map
